import "./style.css";
import Quality from "./components/Layouts/cols/Quality";
import Financial from "./components/Layouts/cols/Financial";
import Operational from "./components/Layouts/cols/Operational";
import HomeProvider from "./HomeProvider";
import { useTranslation } from "react-i18next";
import { Block, CRIcon } from "@/components/crRender";
import ActionBtn from "@/components/ActionBtn";
import { useNavigate } from "react-router-dom";
import { ROLES } from "@/data/Constant";
import { PrivilegeContext } from "@/context/PrivilegesContext";
import { useContext } from "react";
const HomePage = () => {
  const { t } = useTranslation();
  const { userRoleId } = useContext(PrivilegeContext);
  const navigate = useNavigate();

  const handleCompleteProfile = () => {
    navigate("/panel/provider-profile");
  }
  return (
    <HomeProvider>
    {/* <div className="home-layout">*/}
       {/* <Quality /> */}
        {/* <Operational /> */}
        {/* <Financial /> */}
       <Block isRender={ROLES.PROVIDER==userRoleId} className="complete-profile-wrapper">
         <div className="complete-profile-card">
           <div className="complete-profile-icon">
             <CRIcon icon="mdi:account-edit-outline" />
           </div>
           <h2 className="complete-profile-title">{t("complete-your-profile")}</h2>
           <p className="complete-profile-desc">{t("complete-your-profile-to-get-started")}</p>
           <ActionBtn title="complete-profile" onApply={handleCompleteProfile} className="complete-profile-btn" />
         </div>
       </Block>
     {/* </div> */}
    </HomeProvider>
  );
};

export default HomePage;
